import React, { useState } from 'react';
import Dialog from '../Dialog/Dialog';
import Button from '../Button/Button';
import Input from '../Input/Input';
import Dropdown from '../Dropdown/Dropdown';
import './CreateProjectDialog.css';

interface CreateProjectDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, placeholderFormat: string) => Promise<void>;
  isLoading: boolean;
}

const CreateProjectDialog: React.FC<CreateProjectDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  isLoading
}) => {
  const [name, setName] = useState('');
  const [format, setFormat] = useState('web');

  const handleSubmit = async () => {
    if (name.trim()) {
      await onSave(name.trim(), format);
      setName('');
      setFormat('web');
    }
  };

  const formatOptions = [
    {
      id: 'formats',
      items: [
        { id: 'web', label: 'Web {name}', value: 'web' },
        { id: 'unified', label: 'Unified [name]', value: 'unified' },
        { id: 'ios', label: 'iOS %@', value: 'ios' },
        { id: 'android', label: 'Android %1$s', value: 'android' },
        { id: 'lokalise', label: 'Lokalise [%name$s]', value: 'lokalise' }
      ]
    }
  ];

  const headerActions = (
    <div className="dialog-header-actions">
      <Button 
        variant="secondary" 
        onClick={onClose}
        disabled={isLoading}
        size="small"
      >
        Cancel
      </Button>
      <Button 
        variant="primary" 
        onClick={handleSubmit}
        disabled={isLoading || !name.trim()}
        isLoading={isLoading}
        size="small"
      >
        Create
      </Button>
    </div>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Create Project"
      headerActions={headerActions}
      showCloseButton={false}
    >
      <div className="create-project-dialog">
        <Input
          label="Project Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter project name"
          disabled={isLoading}
          required
        />

        <div className="format-options">
          <div className="format-selector">
            <div className="option-text">
              <span className="option-title">Placeholder Format</span>
            </div>
            <Dropdown
              items={formatOptions}
              selectedId={format}
              onSelect={(value) => setFormat(value)}
              disabled={isLoading}
              hasSections={true}
              position="right"
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default CreateProjectDialog; 